import React from 'react'
import styled, { css } from 'styled-components'

const Badge2 = ({ status = 'success', children }) => {
    return (
        <StyledBadge status={status}>{children}</StyledBadge>
    )
}

export default Badge2


const successStyle = css`
    background: linear-gradient(to right, #0486D6, #03ADEF);
`

const dangerStyle = css`
background: linear-gradient(to right, #A51824, #FC1D26);
    
`

const getTypeStyle = (status) => {
    switch (status) {
        case 'success': return successStyle
        case 'danger': return dangerStyle
        default: return successStyle
    }
}

const StyledBadge = styled.div`
    ${props => getTypeStyle(props.status)};
    padding: 5px 8px;
    display: inline-block;
    border-radius: 50px;
    color: ${props => props.theme.white};
    text-transform: uppercase;
    font-size: 10px

`